/**
 * Dismiss state for the BATON connection-lost banner (#15).
 * Dismiss hides the banner until cloud transport reconnects or a new outage cycle starts.
 */

const DISMISS_KEY = 'maestro_baton_banner_dismissed';

export function isBatonBannerDismissed(): boolean {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissBatonBanner(): void {
  try {
    sessionStorage.setItem(DISMISS_KEY, '1');
  } catch { /* ignore */ }
}

export function clearBatonBannerDismiss(): void {
  try {
    sessionStorage.removeItem(DISMISS_KEY);
  } catch { /* ignore */ }
}
